import React from "react";
import Banner from "../components/Banner";
import IngredientsSection from "../components/IngredientsSection";
import ProductsSection from "../components/ProductsSection";

const Home = () => {
  return (
    <div>
      <Banner />
      <IngredientsSection />
      <ProductsSection />
    </div>
  );
};

export default Home;
